<span
    class="headline-small kh-header-spacing"
    [class.kh-header-spacing--has-subheader]="hasSubheader"
    ><ng-content></ng-content
></span>
